import React, { useState, useMemo, useCallback } from 'react';

import AutoLink from "Components/AutoLink";
import DetailViewer from "./DetailViewer";
import ChatHeader from "../../ChatHeader";
import DialogPortal from "Components/DialogPortal";
import ImageViewer from "Components/ImageViewer";

import util from 'util/baseUtil';

const ChannelTalkViewer = ({ attach, headerData, callback}) => {
  const [imageDetail, setImageDetail] = useState(null);
  const [blockShortCut, setBlockShortCut] = useState(false);
  const {roomInfo, writerInfo, date} = headerData;
  
  const {content, file} = attach    //둘 다 배열

  const handleDownload = useCallback((save_file, file_name) => {
    util.download(`${process.env.REACT_APP_FILE_API_URL}?type=1&serverfile=${save_file}`, file_name);
  },[]);


  const openImageViewer = useCallback(save_file => {
    setBlockShortCut(true);
    setImageDetail({
      save_file: save_file,
      org_file: save_file,
    })
  },[]);

  
  const closeImageViewer = useCallback(() => {
    setBlockShortCut(false);
    setImageDetail(null)
  },[]);


  const message = useMemo(()=>{
    return content.map(item => {
      const {data, imgName, type, idx} = item;
      switch(type) {
        case "1": //이미지
          return (
              <figure key={`channelTalkContent_${idx}`} onClick={openImageViewer.bind(null, imgName)}>
                <img src={`${process.env.REACT_APP_FILE_API_URL}?type=1&serverfile=${imgName}`} alt={imgName} />
              </figure>
            )
        case "4": //이모티콘
          const emoticon = data.split('|');
          return <img key={`channelTalkContent_${idx}`} className="emoticon" src={`${process.env.REACT_APP_FILE_API_URL}?type=10&serverfile=${emoticon[1]}/${emoticon[0]}.${emoticon[2] === 'gif' ? 'gif' : 'png'}&device=web`} data-emoji={`이모티콘:${emoticon[1]}/${emoticon[0]}`} alt={`이모티콘:${emoticon[1]}/${emoticon[0]}`} />
        default:
          return <AutoLink key={`channelTalkContent_${idx}`} text={data} setParentBlockShortCut={setBlockShortCut}/>;
      }
    })
  },[content, openImageViewer])


  const fileDom = useMemo(()=>{
    if (!file || file.length === 0) {
      return null;
    }

    return (
      <div className="file">
        <button type="button" className="fileCnt" >첨부파일 <span>{file.length}</span>개</button>
        <ul>
          {file.map(item => {
            const {idx, save_file, file_name, file_size, end_date} = item;
            return (
              <li key={`${save_file}_${idx}`}>
                <button 
                  type="button" 
                  onClick={handleDownload.bind(null, save_file, file_name)} 
                  title={`${file_name} \n\n유효기간 : ${('~' + end_date || '-').replace(/\//g, '.')}\n용량 : ${util.formatFileSize(file_size)}`}>
                    {file_name}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    )
  },[file, handleDownload])


  const imagePopup = useMemo(()=>{
    if (!imageDetail) {
      return null
    }
    return (
      <DialogPortal>
        <ImageViewer attach={imageDetail} callback={closeImageViewer} />
      </DialogPortal>
    )
  },[imageDetail, closeImageViewer]);

  return (
    <DetailViewer body={(
      <>
        <ChatHeader roomInfo={roomInfo} writerInfo={writerInfo} date={date} />
        <div className="cont">
          <div className="txt">
            <div className="data">
              {message}
            </div>
          </div>
          {fileDom}
        </div>
        {imagePopup}
      </>
    )} callback={callback} blockShortCut={blockShortCut} />
  )
}

export default ChannelTalkViewer;